<template>
  <div class='procedure-editor'>
    <template v-if='!showEdit'>
      <process-view :users='users' v-if='!showEdit' :turn_off_completion='turn_off_completion' :can='can' />
    </template>
    <process-admin v-if='showEdit' :dark_mode='dark_mode' />
    <div class='procedure__blank' v-if='tasksLength == 0 && !showEdit'>
      <p>There are no tasks in this process yet.</p>
    </div>

  </div>
</template>

<script>
import flash from "../lib/flashes.js";
import { mapState, mapGetters } from 'vuex'
import ProcessAdmin from './processor/Admin.vue';
import ProcessView from './processor/View.vue'
import * as ClipboardFunctions from "../lib/ClipboardFunctions.js";

export default {
  props: ["url", "users", "can", "turn_off_completion", "id", "dark_mode", "asset_name", "structure_name"],
  components: {
    ProcessAdmin,
    ProcessView
  },
  computed: {
    ...mapState("procedures", {
      'showEdit':  'showEdit',
      'procedure': 'procedure',
      'showDescription': 'showDescription',
      'openProcessView': 'openProcessView',
      'openProcessEdit': 'openProcessEdit',
      'openCompletionEdit': 'openCompletionEdit',
    }),
     ...mapGetters("procedures", {
      'tasksLength':  'tasksLength',
      'procedureJSON': 'procedureJSON'
    }),
    name: {
      get() {
        return this.$store.state.procedures.procedure.name
      },
      set(value) {
        this.$store.dispatch('procedures/updateProcedureName', value)
      }
    },
    description: {
      get() {
        return this.$store.state.procedures.procedure.description
      },
      set(value) {
        this.$store.dispatch('procedures/updateProcedureDescription', value)
      }
    },
    procedure_tasks_attributes: {
      get() {
        return this.procedure.procedure_tasks_attributes
      },
      set(value) {
        this.$store.dispatch('procedures/update_tasks', value)
      }
    }
  },
  mounted () {
    this.$store.dispatch('procedures/setState', [this.url, this.can, this.template])
    this.$store.dispatch('procedures/fetch');

    // Add a simple observer to watch for when procedure content appears
    const observer = new MutationObserver(() => {
      if (window.Prism && window.Prism.plugins && window.Prism.plugins.toolbar) {
        // Find any unhighlighted code blocks in procedure content
        const procedureArea = document.querySelector('.procedure-steps')
        if (procedureArea) {
          const codeBlocks = procedureArea.querySelectorAll('pre:not(.code-toolbar pre)')
          if (codeBlocks.length > 0) {
            // Highlight each code block and manually trigger toolbar
            codeBlocks.forEach(pre => {
              const code = pre.querySelector('code')
              if (code) {
                window.Prism.highlightElement(code)
                // Manually trigger the toolbar plugin
                window.Prism.plugins.toolbar.hook({ element: code })
              }
            })
          }
        }
      }
    })
    
    // Start observing
    observer.observe(document.body, { childList: true, subtree: true })
    
    // Clean up observer when component is destroyed
    this.mutationObserver = observer
  },
  beforeDestroy() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect()
    }
  },
  methods: {
    toggleEdit () {
      this.$store.dispatch('procedures/toggleEdit');
    },
    toggleDescription () {
      this.$store.dispatch('procedures/toggleDescription');
    },
    toggleSplitLayout () {
      this.$store.dispatch('procedures/toggleSplitLayout');
    },
    copyCompletedTasks () {

      if (this.procedure.completed == 0) {
        return alert("Complete tasks first!")
      }
      var that = this;
      var text = "";
      that.procedure.procedure_tasks_attributes.forEach ( function (item, idx) {
        if (item.completed ) {
          if (item.completion_notes) {
            text += `✔ COMPLETED - ${item.name} - ${item.completed_date}. Completion Notes: ${item.completion_notes}`;
          } else {
            text += `✔ COMPLETED - ${item.name} - ${item.completed_date}`;
          }

          if (idx != that.procedure.procedure_tasks_attributes.length - 1) {
            text += "\n";
          }
        }
      })
      ClipboardFunctions.copyText(text);

      text = "";

      flash("Copied!", "success")
    }
  }
}
</script>

